class GridSelector {
  constructor() {
    this.storageKey = 'grid-selector-preference';
    this.productGrid = document.getElementById('product-grid');
    this.buttons = Array.from(document.querySelectorAll('.grid-selector-btn'));
    this.current = this._readPreference() || this._defaultsFromDom() || { desktop: 3, mobile: 2 };
    this._bind();
    this._apply();
    this._updateActive();
  }

  _defaultsFromDom() {
    if (!this.productGrid) return null;
    const { defaultGridDesktop, defaultGridMobile } = this.productGrid.dataset;

    const desktop = parseInt(defaultGridDesktop, 10);
    const mobile = parseInt(defaultGridMobile, 10);

    const hasDesktop = !Number.isNaN(desktop);
    const hasMobile = !Number.isNaN(mobile);

    if (!hasDesktop && !hasMobile) return null;

    return {
      desktop: hasDesktop ? desktop : 3,
      mobile: hasMobile ? mobile : 2,
    };
  }

  _readPreference() {
    try { return JSON.parse(sessionStorage.getItem(this.storageKey) || 'null'); } catch(e) { return null; }
  }

  _savePreference() {
    try { sessionStorage.setItem(this.storageKey, JSON.stringify(this.current)); } catch(e) {}
  }

  _bind() {
    this.buttons.forEach(btn => {
      const handler = (e) => {
        e.preventDefault();
        const value = parseInt(btn.getAttribute('data-grid-selector'), 10);
        const isMobile = window.innerWidth < 750;
        if (isMobile) this.current.mobile = value; else this.current.desktop = value;
        this._savePreference();
        this._apply();
        this._updateActive();
      };
      // remove previous handler if any
      if (btn.__gridHandler) btn.removeEventListener('click', btn.__gridHandler);
      btn.__gridHandler = handler;
      btn.addEventListener('click', handler);
    });

    if (!window.__gridSelectorResizeBound) {
      window.addEventListener('resize', () => {
        this._apply();
        this._updateActive();
      });
      window.__gridSelectorResizeBound = true;
    }
  }

  _apply() {
    if (!this.productGrid) return;
    const isMobile = window.innerWidth < 750;

    // Remove known classes
    this.productGrid.classList.remove(
      'grid--1-col-tablet-down','grid--2-col-tablet-down',
      'grid--1-col-desktop','grid--2-col-desktop','grid--3-col-desktop',
      'grid--4-col-desktop','grid--5-col-desktop','grid--6-col-desktop'
    );

    if (isMobile) {
      this.productGrid.classList.add(`grid--${this.current.mobile}-col-tablet-down`);
    } else {
      this.productGrid.classList.add(`grid--${this.current.desktop}-col-desktop`);
    }
  }

  _updateActive() {
    const isMobile = window.innerWidth < 750;
    const value = isMobile ? this.current.mobile : this.current.desktop;
    this.buttons.forEach(btn => {
      const v = parseInt(btn.getAttribute('data-grid-selector'), 10);
      btn.classList.toggle('active', v === value);
    });
  }
}

function initGridSelector(){
  try { new GridSelector(); } catch(e) {}
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGridSelector);
} else {
  initGridSelector();
}

document.addEventListener('shopify:section:load', initGridSelector);
document.addEventListener('collection:rendered', initGridSelector);



